<template>
  <section>
    <div class="owl-carousel owl-theme">
      <div class="adapter-item items" v-for="(banner, i) in banners" :key="i">
        <b-img fluid :src="banner.src" :alt="banner.alt" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      banners: [
        {
          src: require('@/assets/images/home/banner_01.jpg'),
          alt: 'wipe clear explore more'
        },
        {
          src: require('@/assets/images/home/banner_02.jpg'),
          alt: 'wipe clear explore more'
        }
      ]
    }
  },
  mounted() {
    $('.owl-carousel').owlCarousel({
      loop: true,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplaySpeed: 800,
      margin:10,
      responsive:{
          0:{ items:1 }
      }
    })
  },
}
</script>